export { default } from './TimelineOppositeContent';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/TimelineOppositeContent/index.js
// module id = 1402
// module chunks = 121